<template>
  <section v-if="user.information">
    <b-navbar toggleable="false" type="light" class="navbar-expand">
      <b-navbar-nav class="non-clickable">
        <b-breadcrumb :items="crumbs" @click="gotoLink"></b-breadcrumb>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto hidden-not-mobile">
        <b-nav-item-dropdown right no-caret>
          <template #button-content>
            <i class="fa fa-bars nav-icon" />
          </template>
          <b-dropdown-text>
            <ProfileInfo></ProfileInfo>
          </b-dropdown-text>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :href="sefos_url"  v-b-tooltip.hover title="SEFOS for Web" target="_blank">
            <i class="fal fa-cog"></i> SEFOS for Web
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="#" v-b-tooltip.hover :title="$t('LOGOUT')" @click="logoutAction">
              <i class="fal fa-sign-out"></i> {{ $t('LOGOUT') }}
            </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto hidden-mobile">
        <b-nav-item :href="sefos_url" v-b-tooltip.hover title="SEFOS for Web" target="_blank"><i class="fal fa-cog"></i
          ></b-nav-item>
          <b-nav-item-dropdown
          right
          no-caret
          z-index="1000"
          menu-class="header-big"
          class="ml-2 mr-2"
          v-b-tooltip.hover
          :title="user.information.name"
        >
          <template #button-content>
            <i class="fal fa-user-alt"></i>
          </template>
          <b-dropdown-text>
            <ProfileInfo />
          </b-dropdown-text>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#" @click="logoutAction">{{
            $t("LOGOUT")
          }}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-text class="mr-2 hidden-mobile">
          <div class="navbarInfo">{{ $t('ADMINLEVEL.ADMINRIGHTS.' + user.information.is_admin) }}</div>
          <div class="navbarInfoSmall">{{ userLoa }}</div>
        </b-nav-text>        
       

      </b-navbar-nav>
    </b-navbar>
  </section>
</template>
<script>
import ProfileInfo from "@/components/Layout/ProfileInfo";
export default {
  components: { ProfileInfo },
  data() {
    return {
    };
  },
  methods: {
    gotoLink(){
      this.$emit('gotoLink');
    },
    logoutAction() {
      let self = this;
      self.$store.dispatch("user/setRedirectUrl", window.location.href);
      self.$store.dispatch("user/NotAuthenticated");
      self.$router.push({ name: "Login" });
      /*this.$http.get(this.user.hostname + '/server/rest/logout').finally(function() {
        self.$store.dispatch("user/NotAuthenticated");      
         self.$router.push({ name: "Login" });  
      });*/
    },
  },
  computed: {
    primaryInfo(){
      let info = this.user.information.name;
      if(this.user.information.title)
      {
        info += ", " + this.user.information.title;
      }
      return info;
    },
    crumbs: function() {
      let pathArray = this.$route.path.split("/");
      pathArray.shift()
      //console.log(pathArray);      
      let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {                        
        if(this.$route.matched[idx] != undefined)
        {
          if(this.$route.matched[idx].meta != undefined)
          {
            if(this.$route.matched[idx].meta.breadCrumb != undefined)
            {
              if(this.$route.matched[idx].meta.breadCrumb != "")
              {
                breadcrumbArray.push({
                  to: { name: this.$route.matched[idx].name },
                  text: this.$t(this.$route.matched[idx].meta.breadCrumb),
                });
              }
            }
          }
        }
        return breadcrumbArray;
      }, []);
      if(this.$route.meta.crumbParam != undefined)
        {
          for (var key of Object.keys(this.$route.params)) {
            if(this.$route.meta.crumbParam == key)
            {
              breadcrumbs.push({
                path: '#',
                text: this.$route.params[key],
              });
            }
          }
        }
      return breadcrumbs;
    },
    sefos_url() {
      return this.user.hostname.replace("/server/rest", "");
    },
    userLoa(){
      if(this.user.information)
      {
        return this.$t('LOA.NAME') + " " + this.user.information.loa;
      }else{
        return "";
      }
    }
  },
};
</script>
<style></style>
